import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // if you're using React Router
import { searchRides } from '../firebase/algoliaService';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import RideCardSimple from '../components/RideCardSimple';
import { getAllRides, getUserInfo } from '../firebase/FirebaseManagement';
export default function AllRexRides() {
  const navigate = useNavigate();
  const [ridesDetails, setRidesDetails] = useState(null);
  useEffect(() => {
    const fetchRides = async () => {
      const rides = await getAllRides();
      setRidesDetails(rides);
    };

    fetchRides();
  }, []);

  return (
    <div >
      <h1 className='text-3xl'>Search all Rex<span className='span-titles'>Rides</span></h1>
      <div className='flex flex-wrap gap-4 mt-[40px] justify-center'>
        {ridesDetails?.map((rideDetail, index) => {
                  return (
                    <div
                      className="mb-4 max-w-[600px] min-w-[400px]"
                      index={index}
                      onClick={() => navigate(`/rexridecheckout/${rideDetail.id}`)}
                    >
                      <RideCardSimple key={index} rideDetails={rideDetail} />
                    </div>
                  );
                })}
      </div>
      <Footer />
    </div>
  );
}
